var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { resetAppStateAction } from "actions/application";
import { createLearningTaskAnswer, createLearningTaskAnswerVersion, deleteLearningTaskAnswerVersionAttachment, getLearningTasks, updateLearningTaskAnswerVersion, } from "api/learningTasks";
const initialState = { isLoading: false, models: [], errors: [], answerLastSavedAt: null };
export const getLearningTasksAction = createAsyncThunk("learningTasks/load", (categoryId) => __awaiter(void 0, void 0, void 0, function* () { return yield getLearningTasks(categoryId); }));
export const updateLearningTaskAnswerVersionAction = createAsyncThunk("learningTaskAnswerVersion/update", (data) => __awaiter(void 0, void 0, void 0, function* () { return yield updateLearningTaskAnswerVersion(data); }));
export const createLearningTaskAnswerVersionAction = createAsyncThunk("learningTaskAnswersVersion/create", (data) => __awaiter(void 0, void 0, void 0, function* () { return yield createLearningTaskAnswerVersion(data); }));
export const createLearningTaskAnswerAction = createAsyncThunk("learningTaskAnswers/create", (taskId) => __awaiter(void 0, void 0, void 0, function* () { return yield createLearningTaskAnswer(taskId); }));
export const deleteLearningTaskAnswerVersionAttachmentAction = createAsyncThunk("learningTaskAnswerVersionAttachment/delete", (data) => __awaiter(void 0, void 0, void 0, function* () { return yield deleteLearningTaskAnswerVersionAttachment(data); }));
const setIsLoading = (state) => {
    state.isLoading = true;
    state.errors = [];
};
const replaceLearningTasks = (state, action) => {
    state.isLoading = false;
    state.models = action.payload;
};
const replaceLearningTaskAnswer = (state, action) => {
    const response = action.payload;
    const newTasks = state.models.map((t) => {
        if (t.id === response.taskId) {
            return Object.assign(Object.assign({}, t), { answer: response });
        }
        return t;
    });
    state.models = newTasks;
    state.answerLastSavedAt = Date.now();
};
const replaceLearningTaskAnswerVersion = (kind) => (state, action) => {
    const response = action.payload;
    const newTasks = state.models.map((t) => {
        var _a;
        if (t.answer && ((_a = t.answer) === null || _a === void 0 ? void 0 : _a.id) === response.answerId) {
            let newVersions;
            if (kind == "update") {
                newVersions = t.answer.versions.map((v) => {
                    if (v.id == response.id) {
                        return response;
                    }
                    else {
                        return v;
                    }
                });
            }
            else {
                newVersions = [response, ...t.answer.versions];
            }
            return Object.assign(Object.assign({}, t), { answer: Object.assign(Object.assign({}, t.answer), { versions: newVersions }) });
        }
        return t;
    });
    state.models = newTasks;
    state.answerLastSavedAt = Date.now();
};
const replaceErrors = (state, error) => {
    state.isLoading = false;
    state.errors = [error];
};
const learningTasksSlice = createSlice({
    name: "learningTasks",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getLearningTasksAction.pending, setIsLoading)
            .addCase(getLearningTasksAction.fulfilled, replaceLearningTasks)
            .addCase(getLearningTasksAction.rejected, (state, action) => replaceErrors(state, action.error))
            .addCase(updateLearningTaskAnswerVersionAction.pending, setIsLoading)
            .addCase(updateLearningTaskAnswerVersionAction.fulfilled, replaceLearningTaskAnswerVersion("update"))
            .addCase(updateLearningTaskAnswerVersionAction.rejected, (state, action) => replaceErrors(state, action.error))
            .addCase(createLearningTaskAnswerVersionAction.pending, setIsLoading)
            .addCase(createLearningTaskAnswerVersionAction.fulfilled, replaceLearningTaskAnswerVersion("create"))
            .addCase(createLearningTaskAnswerVersionAction.rejected, (state, action) => replaceErrors(state, action.error))
            .addCase(createLearningTaskAnswerAction.pending, setIsLoading)
            .addCase(createLearningTaskAnswerAction.fulfilled, replaceLearningTaskAnswer)
            .addCase(createLearningTaskAnswerAction.rejected, (state, action) => replaceErrors(state, action.error))
            .addCase(deleteLearningTaskAnswerVersionAttachmentAction.pending, setIsLoading)
            .addCase(deleteLearningTaskAnswerVersionAttachmentAction.fulfilled, replaceLearningTaskAnswerVersion("update"))
            .addCase(deleteLearningTaskAnswerVersionAttachmentAction.rejected, (state, action) => replaceErrors(state, action.error))
            .addCase(resetAppStateAction, () => initialState);
    },
});
export default learningTasksSlice;
